"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.NestedHeaders = void 0;
var _nestedHeaders = require("./nestedHeaders");
exports.PLUGIN_KEY = _nestedHeaders.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _nestedHeaders.PLUGIN_PRIORITY;
exports.NestedHeaders = _nestedHeaders.NestedHeaders;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/nestedHeaders/index.js
// module id = 1505
// module chunks = 0